import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Coins, Github, Twitter } from 'lucide-react';

export default function Footer() {
  const location = useLocation();

  const handleMasternodesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      window.location.href = '/#masternodes';
    } else {
      const element = document.getElementById('masternodes');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleDevFundClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      window.location.href = '/#devfund';
    } else {
      const element = document.getElementById('devfund');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-slate-900 py-12 px-6">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <Coins className="h-8 w-8 text-green-500" />
              <span className="text-2xl font-bold">TWINS</span>
            </div>
            <p className="text-gray-400">
              Open source, peer-to-peer cryptocurrency
            </p>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/whitepaper" className="hover:text-green-400">Whitepaper</Link></li>
              <li><Link to="/api" className="hover:text-green-400">API</Link></li>
              <li><a href="#masternodes" onClick={handleMasternodesClick} className="hover:text-green-400">Masternodes</a></li>
              <li><a href="#devfund" onClick={handleDevFundClick} className="hover:text-green-400">Dev Fund</a></li>
              <li><Link to="/privacy" className="hover:text-green-400">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-green-400">Terms of Use</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Community</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="https://twitter.com/TWINS_Coin" target="_blank" rel="noopener noreferrer" className="hover:text-green-400">Twitter</a></li>
              <li><a href="https://github.com/NewCapital/TWINS-go" target="_blank" rel="noopener noreferrer" className="hover:text-green-400">GitHub</a></li>
              <li><a href="https://discord.gg/zZbnYKV" target="_blank" rel="noopener noreferrer" className="hover:text-green-400">Discord</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Network</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="https://explorer.win.win" target="_blank" rel="noopener noreferrer" className="hover:text-green-400">Explorer</a></li>
              <li><a href="https://docs.win.win/twins" target="_blank" rel="noopener noreferrer" className="hover:text-green-400">Documentation</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} TWINS. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="https://github.com/NewCapital/TWINS-go" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
              <Github className="h-5 w-5" />
            </a>
            <a href="https://twitter.com/TWINS_Coin" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
              <Twitter className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}